module.exports = {"cooking_board_title":"I BESTILLING","ready_board_title":"FERDIG","404_not_found":"404 - Not found","not_found_text":"It looks like the page you have requested doesn’t exist.\nPlease check you’ve typed the URL correctly or begin from the homepage.","403_access_denied":"403 - Access denied","access_denied_text":"Sorry, you’re not allowed to access this page.","monitor_error_title":"FEIL","monitor_error_text":"Monitoren for matbestillinger fungerer ikke","monitor_error_desc":"Systemet er deaktivert eller URL’n er ugyldig"}


//////////////////
// WEBPACK FOOTER
// ./lang/no/food-monitor-no.json
// module id = 887
// module chunks = 6